import { PropertyDataCommerce } from './components';

export const StepThree = () => <PropertyDataCommerce />;
